export default __webpack_public_path__ + "static/media/icon.df2eb0cd.ico";